/* eslint-disable import/prefer-default-export */
export const getMyContactsFilter = (MEMBER, trayID) => {
  const trayMap = {
    all: {
      $or: [
        // Canales WhatsAppContact (legacy)
        { type: 'WhatsAppContact' },
        // Canales WhatsAppGuest con subtype 'contact' (nuevo sistema)
        { type: 'WhatsAppGuest', subtype: 'contact' },
        // Conversaciones entre colegas
        { type: 'Colleague' },
      ],
      members: MEMBER,
      frozen: false,
    },
    whatsapp: {
      $or: [
        { type: 'WhatsAppContact' },
        { type: 'WhatsAppGuest', subtype: 'contact' },
      ],
      members: MEMBER,
      frozen: false,
    },
    colleague: {
      type: { $in: ['Colleague'] },
      members: MEMBER,
      frozen: false,
    },
  };

  return trayMap[trayID];
};

export const getGroupsFilter = (MEMBER, trayID) => {
  const trayMap = {
    all: {
      type: 'network',
      members: MEMBER,
      frozen: false,
    },
    whatsapp: {
      type: 'network',
      members: MEMBER,
      frozen: false,
    },
    colleague: {
      type: { $in: ['not-channel'] },
      members: MEMBER,
    },
  };

  return trayMap[trayID];
};

export const getWatcherFilterConfig = (trayID, canManageWebContacts) => {
  // En modo watcher solo mostramos canales de WhatsApp y Colleague
  // NO incluimos team ni network
  const defaultChannels = ['Colleague', 'WhatsAppContact'];

  const trayMapping = {
    whatsapp: ['WhatsAppContact'],
    colleague: ['Colleague'],
  };

  // Agregar WhatsAppGuest si el agente tiene permisos
  if (canManageWebContacts) {
    defaultChannels.push('WhatsAppGuest');
    trayMapping.whatsapp.push('WhatsAppGuest');
  }

  // Si hay un mapeo específico para el trayID, usarlo
  if (trayMapping[trayID]) {
    const trayTypes = [...trayMapping[trayID]];
    // Siempre incluir Colleague si no está (excepto si el tray es colleague que ya lo tiene)
    if (!trayTypes.includes('Colleague')) {
      trayTypes.push('Colleague');
    }
    return {
      $in: trayTypes,
    };
  }

  // Para 'all' o cualquier otro caso, retornar WhatsApp + Colleague
  return {
    $in: defaultChannels,
  };
};

/**
 * Aplica filtros según la pestaña activa para filtrar canales por tipo de instancia.
 * Usa los campos personalizados instance_type y subtype para categorizar los canales.
 *
 * @param {Object} config - Configuración base de filtros de Stream Chat
 * @param {string} activeTab - Pestaña activa: 'my_chats' | 'branch' | 'company'
 * @param {number|null} selectedBranchId - ID de la branch seleccionada (opcional)
 * @param {string} trayID - Tray activo: 'all' | 'whatsapp' | 'colleague'
 * @returns {Object} Configuración de filtros actualizada según la pestaña
 */
export const applyTabFilter = (
  config,
  activeTab,
  selectedBranchId = null,
  trayID = 'all'
) => {
  if (!activeTab || activeTab === 'my_chats') {
    // El $or de my_chats se restringe según el tray activo para no contaminar
    // el filtro de tipo (ej: tray whatsapp no debe mostrar team/Colleague/network)
    const myChatsConditionsByTray = {
      whatsapp: [
        { type: 'WhatsAppContact' },
        { type: 'WhatsAppGuest', subtype: 'contact' },
        { type: 'WhatsAppGuest', subtype: 'inquiry', instance_type: 'agent' },
      ],
      all: [
        { type: 'WhatsAppContact' },
        { type: 'WhatsAppGuest', subtype: 'contact' },
        { type: 'WhatsAppGuest', subtype: 'inquiry', instance_type: 'agent' },
        { type: 'team' },
        { type: 'Colleague' },
        { type: 'network' },
        { instance_type: 'agent' },
      ],
    };

    // colleague already has type restricted in the base filter — no $or needed
    if (trayID === 'colleague') {
      return config;
    }

    const myChatsConditions =
      myChatsConditionsByTray[trayID] || myChatsConditionsByTray.all;

    return {
      ...config,
      $or: myChatsConditions,
    };
  }

  if (activeTab === 'branch') {
    const branchFilter = {
      ...config,
      instance_type: 'branch',
      subtype: 'inquiry',
    };

    if (selectedBranchId) {
      branchFilter.branch_id = selectedBranchId.toString();
      // eslint-disable-next-line no-unused-vars
      const { members, ...filterWithoutMembers } = branchFilter;
      return filterWithoutMembers;
    }

    return branchFilter;
  }

  if (activeTab === 'company') {
    // Compañía: canales de tipo company con consultas (inquiry)
    // Incluye canales viejos que no tienen instance_type (legacy)
    return {
      ...config,
      // En Company solo deben verse consultas entrantes de WhatsAppGuest
      type: 'WhatsAppGuest',
      $and: [
        {
          $or: [{ subtype: 'inquiry' }, { subtype: { $exists: false } }],
        },
        {
          $or: [
            { instance_type: 'company' },
            { instance_type: { $exists: false } },
          ],
        },
      ],
    };
  }

  return config;
};
